import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { GridEventListener, GridEvents, GridSortModel } from "@mui/x-data-grid-pro";

import { COLLECTION_YARDS_PAGE_PATH } from "../../../middleware/routes";
import {
  cleanUpCollectionPointDetail,
  getCollectionPointDetailThunk,
  setCollectionPoint,
} from "../../../reducers/collectionPointReducer";
import { defaultOrdering } from "../../../reducers/collectionYardsReducer";
import { setCollectionYardsListOrdering } from "../../../reducers/collectionYardsReducer";
import {
  getCollectionYardsOrdering,
  getIsCollectionYardsVisitsStatusLoading,
} from "../../../selectors/collectionYards";
import { buildCollectionPointUrl } from "../../../utils/url";
import { CollectionPointPageTab } from "../../CollectionPointPage";

interface CollectionYardsTableHandlers {
  handleSortModelChange: (model: GridSortModel) => void;
  handleAdditionalRowClick: GridEventListener<GridEvents.rowClick>;
}

export const useGetCollectionYardsTableHandlers = (): CollectionYardsTableHandlers => {
  const dispatch = useDispatch();
  const ordering = useSelector(getCollectionYardsOrdering);
  const isLoading = useSelector(getIsCollectionYardsVisitsStatusLoading);
  const history = useHistory();

  const handleAdditionalRowClick: GridEventListener<GridEvents.rowClick> = (params) => {
    const collectionPointId = params.row.locationId;
    dispatch(cleanUpCollectionPointDetail());
    dispatch(setCollectionPoint(params.row));
    dispatch(getCollectionPointDetailThunk(collectionPointId));

    history.push(
      buildCollectionPointUrl(collectionPointId, {
        prevPage: COLLECTION_YARDS_PAGE_PATH,
        tab: CollectionPointPageTab.CollectionYardVisits,
      })
    );
  };

  const handleSortModelChange = (model: GridSortModel) => {
    if (isLoading) {
      return;
    }

    const field = model[0].field;
    //sort case sensitivity
    const newOrderBy = () => {
      switch (field) {
        default:
          return field;
      }
    };

    const newOrdering = {
      orderBy: newOrderBy(),
      descending: ordering.orderBy === newOrderBy() ? !ordering.descending : defaultOrdering.descending,
    };
    dispatch(setCollectionYardsListOrdering(newOrdering));
  };

  const collectionYardsTableHandlers: CollectionYardsTableHandlers = {
    handleSortModelChange,
    handleAdditionalRowClick,
  };

  return collectionYardsTableHandlers;
};
